import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { AuthProvider, useAuth } from './lib/auth'
import { WebSocketProvider } from './providers/websocket-provider'
import { ProtectedRoute } from './components/ProtectedRoute'
import { Layout } from './components/Layout'
import Home from './pages/Home'
import Login from './pages/Login'
import Signup from './pages/Signup'
import Post from './pages/Post'
import Developers from './pages/Developers'
import Profile from './pages/Profile'
import ResetPassword from './pages/ResetPassword'
import ProjectsDashboard from './pages/ProjectsDashboard'
import ProjectDetail from './pages/ProjectDetail'
import BountyBoard from './pages/BountyBoard'
import PublicProfile from './pages/PublicProfile'
import Messages from './pages/Messages'
import Dashboard from './pages/Dashboard'
import OAuthCallback from './pages/OAuthCallback'
import OnboardingStart from './pages/OnboardingStart'
import Onboarding from './pages/Onboarding'
import OnboardingStaging from './pages/OnboardingStaging'
import DeveloperLanding from './pages/DeveloperLanding'
import AgenticPage from './pages/AgenticPage'
import ProcessPage from './pages/ProcessPage'
import SecurityPage from './pages/SecurityPage'
import InfoPage from './pages/InfoPage'

function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])
  return null
}

function AppRoutes() {
  const { isAuthenticated } = useAuth()

  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* Public routes */}
        <Route
          path="/login"
          element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />}
        />
        <Route
          path="/signup"
          element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <Signup />}
        />
        <Route
          path="/signup/developer"
          element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <Signup />}
        />
        <Route path="/join-developer" element={<DeveloperLanding />} />
        <Route path="/process" element={<ProcessPage />} />
        <Route path="/security" element={<SecurityPage />} />
        <Route path="/agentic" element={<AgenticPage />} />
        <Route path="/info" element={<InfoPage />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/auth/callback" element={<OAuthCallback />} />

        {/* Protected routes with layout */}
        <Route path="/" element={<Home />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Layout>
                <Dashboard />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects"
          element={
            <ProtectedRoute>
              <Layout>
                <ProjectsDashboard />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects/:projectId"
          element={
            <ProtectedRoute>
              <Layout>
                <ProjectDetail />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/post"
          element={
            <ProtectedRoute>
              <Layout>
                <Post />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/bounty-board"
          element={
            <ProtectedRoute>
              <Layout>
                <BountyBoard />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/developers"
          element={
            <ProtectedRoute>
              <Layout>
                <Developers />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/profiles/:username"
          element={
            <ProtectedRoute>
              <Layout>
                <PublicProfile />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Layout>
                <Profile />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/onboarding"
          element={
            <ProtectedRoute>
              <Layout>
                <OnboardingStart />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/onboarding/:submissionId"
          element={
            <ProtectedRoute>
              <Layout>
                <Onboarding />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/onboarding/:submissionId/staging"
          element={
            <ProtectedRoute>
              <OnboardingStaging />
            </ProtectedRoute>
          }
        />
        <Route
          path="/messages"
          element={
            <ProtectedRoute>
              <Layout>
                <Messages />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/messages/:conversationId"
          element={
            <ProtectedRoute>
              <Layout>
                <Messages />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route path="/" element={<Navigate to="/landing" replace />} />

        {/* Catch all route */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </>
  )
}

function App() {
  return (
    <AuthProvider>
      <WebSocketProvider>
        <AppRoutes />
      </WebSocketProvider>
    </AuthProvider>
  )
}

export default App
